<template>
  <MultipleChoicesDropdown
    title="business type"
    :value="startup.business_type"
    :show-clear-all="false"
    :single-choice="false"
    :search-enabled="false"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import BUSINESS_TYPES from '@/services/business-types'

export default {
  computed: {
    choices: () => BUSINESS_TYPES,
    ...mapState({
      startup: (state) => state.startupProfile.startup,
    }),
  },
  methods: {
    onChange(choices) {
      const attr = 'business_type'
      const value = choices.map((c) => c.value)
      this.$store.commit('startupProfile/SET_STARTUP_ATTR', { attr, value })
    },
  },
}
</script>
